<!--
  --
  -- データ要素コンポーネント
  --
  -->
<template>
  <div
    class="c-confirm-data-row"
    :class="classes"
    :style="{'padding-left': indentWidth }"
  >
    <!-- ラベル -->
    <div class="c-confirm-data-label">
      <span>{{label}}</span>
    </div>

    <!-- 数量 -->
    <div class="c-confirm-data-quantity">
      <span>{{quantity}}</span>
      <small v-if="unit" class="ml-2 text--secondary">{{unit}}</small>
    </div>

    <!-- 料金 -->
    <div class="c-confirm-data-charge">
      <span>{{charge | comma}}</span>
      <small class="ml-2 text--secondary">円</small>
    </div>
  </div>
</template>

<style lang="scss">
.c-confirm-data-row {
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;

  .c-confirm-data-label {
    flex-grow: 1;
  }

  .c-confirm-data-quantity {
    display: none;
  }

  .c-confirm-data-charge {
    display: none;
  }
}

.c-confirm-data-row.has-quantity {
  .c-confirm-data-label {
    flex-grow: 0;
    width: 100%;
  }

  .c-confirm-data-quantity {
    display: block;
    margin-left: 2rem;
    flex-grow: 1;
  }
}

.c-confirm-data-row.has-charge {
  .c-confirm-data-charge {
    display: block;
    width: 5em;
    text-align: right;
  }
}
</style>

<script>
export default {
  name: 'CDataRow',
  props: {
    // 字下げ
    indent: {
      type: Number,
      default: 0
    },

    // ラベル
    label: {
      type: String
    },

    // 数量
    quantity: {
      type: Number
    },

    // 単位
    unit: {
      type: String
    },

    // 金額
    charge: {
      type: Number
    },

    // 強調
    em: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes () {
      return {
        'text--primary': this.em,
        'font-weight-bold': this.em,
        'pt-4': this.em,
        'has-quantity': this.quantity !== undefined,
        'has-charge': this.charge !== undefined
      }
    },

    indentWidth () {
      return `${this.indent}rem`
    }
  }
}
</script>
